var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.286 1.573l1.717 1.744a.37.37 0 0 0 .53 0 .385.385 0 0 0 0-.539L4.286.495V.43H4.22L3.908.112a.37.37 0 0 0-.53 0L.753 2.778a.385.385 0 0 0 0 .539.37.37 0 0 0 .53 0l2.003-2.034v8.146h1V1.573z",
    fillRule: "nonzero",
    fill: "#841D64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortUp);
export default __webpack_public_path__ + "static/media/sort-up.01a217c99d84a82db26b29054068bcab.svg";
export { ForwardRef as ReactComponent };